<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title><fa-icon [icon]="['fas','building']"></fa-icon>&nbsp;&nbsp;Administratif</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
            <div fxFlex>
                <mat-checkbox #gdprCheck class="example-margin" [(ngModel)]="gdpr">A signé le document GDPR</mat-checkbox> ({{gdprDate}})
            </div>
            <div fxFlex>
                <button mat-raised-button color="primary" [disabled]="gdprCheck.checked" (click)="print()">Imprimer le document GDPR</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>